import React from 'react';
import DatePicker from 'react-datepicker';

import CustomInput from './CustomInput/CustomInput';
import '../SessionDatePicker/styles.css';

export interface Props {
  isDisabled?: boolean;
  filterTime?: (pickerTime: Date) => boolean;
  onChange: (selectedTime: Date) => void;
  selectedDatetime?: Date;
  timeIntervals: number;
}

const SessionTimePicker: React.FC<Props> = ({
  isDisabled = false,
  filterTime,
  onChange,
  selectedDatetime,
  timeIntervals,
}) => {
  return (
    <DatePicker
      calendarClassName="border-none shadow-lg font-sans px-2"
      customInput={<CustomInput isDisabled={isDisabled} selectedDatetime={selectedDatetime} />}
      dateFormat="h:mm aa"
      disabled={isDisabled}
      filterTime={filterTime}
      onChange={onChange}
      popperProps={{ positionFixed: true }}
      selected={selectedDatetime}
      showPopperArrow={false}
      showTimeSelect
      showTimeSelectOnly
      timeClassName={() => 'flex justify-center items-center px-2 rounded'}
      timeIntervals={timeIntervals}
      wrapperClassName="w-full"
    />
  );
};

export default SessionTimePicker;
